export default function DesktopWin(){
    return(
        <img alt="" src="assets/desktop_filled.png" className="desktopWinFrame"/>
    )
}